// extracted by mini-css-extract-plugin
module.exports = {"footer":"z_M g_r"};